module.exports = __webpack_public_path__ + "static/media/memory.2f87db8d.png";